import { render, staticRenderFns } from "./CommonHTMXComponent.vue?vue&type=template&id=4c12696e"
import script from "./CommonHTMXComponent.vue?vue&type=script&lang=js"
export * from "./CommonHTMXComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports